import {useDispatch, useSelector} from "react-redux";
import {css} from "@panda/css";

import {CloseIcon} from "@pg-design/icons-module";
import {Modal} from "@pg-design/modal-module";
import {Text} from "@pg-design/text-module";
import {themeRP as theme} from "@pg-design/themes";

import {IRootState} from "../../store/store";
import {closeAuthModal, setLastAuthAction} from "../state/auth_modal_slice";
import {AuthActionType} from "../types/AuthActionType";
import {AuthModalBenefitDescription} from "./auth_modal/AuthModalBenefitDescription";
import {getAuthModalHeaderContent} from "./auth_modal/AuthModalHeaderVariants";
import {AuthCard} from "./AuthCard";

export const AuthModal = () => {
    const dispatch = useDispatch();
    const authModalState = useSelector((state: IRootState) => state.authModal);

    const onAuthSuccess = (authActionType: AuthActionType) => {
        dispatch(setLastAuthAction({authAction: authActionType}));
        dispatch(closeAuthModal());
    };

    const onClose = () => {
        dispatch(closeAuthModal());
    };

    if (!authModalState.isOpen || !authModalState.userSource) {
        return null;
    }

    const headerContent = getAuthModalHeaderContent(authModalState.headerVariant);

    return (
        <Modal isOpen shouldCloseOnEsc={false} shouldCloseOnOverlayClick={false} onModalClose={onClose}>
            <div className={modalContentStyle}>
                <div className={modalContentAuthCardWrapperStyle}>
                    <div className={closeButtonStyle} onClick={onClose}>
                        <CloseIcon size="1.6" />
                    </div>
                    <AuthCard
                        variant={authModalState.modalVariant}
                        onAuthSuccess={onAuthSuccess}
                        userSource={authModalState.userSource}
                        gtmSourceSection={authModalState.gtmSourceSection}
                        modalTitle={
                            <div className={headerSectionStyle}>
                                <Text align="center" variant="headline_3" className={headerTitleTextStyle}>
                                    {headerContent.title}
                                </Text>
                                <Text align="center" as="div" className={headerDescriptionTextStyle} color={theme.colors.gray[700]} variant="body_copy_2">
                                    {headerContent.description}
                                </Text>
                            </div>
                        }
                        modalDescription={null}
                        className={authCardStyle}
                        wrapperClassName={authCardWrapperStyle}
                    />
                </div>
                <AuthModalBenefitDescription className={benefitDescriptionWrapperStyle} variant={authModalState.headerVariant} />
            </div>
        </Modal>
    );
};

const modalContentStyle = css({
    display: "flex",
    flexDirection: "column",
    padding: 1.5,
    background: "var(--colors-info)",
    md: {
        width: "min(90dvw, 120rem)",
        alignItems: "flex-start",
        flexDirection: "row-reverse",
        padding: 4,
        maxHeight: "calc(100dvh - 8rem)",
        overflow: "auto"
    }
});

const modalContentAuthCardWrapperStyle = css({
    position: "relative"
});

const benefitDescriptionWrapperStyle = css({
    paddingY: 4,
    md: {
        padding: 4
    }
});

const authCardStyle = css({
    flex: "0 0 55rem",
    width: "100%",
    borderRadius: 2,
    boxShadow: "4",
    padding: 1.5,
    background: "white",
    "@media (min-width: 768px)": {
        width: "auto"
    },
    md: {
        width: "55rem",
        padding: 2
    }
});

const authCardWrapperStyle = css({
    padding: 0,
    md: {
        padding: 1,
        width: "auto"
    }
});

const headerSectionStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 1,
    marginBottom: 3,
    paddingRight: 3
});

const headerTitleTextStyle = css({
    textAlign: "center",
    md: {
        textAlign: "left"
    }
});

const headerDescriptionTextStyle = css({
    textAlign: "center",
    md: {
        textAlign: "left"
    }
});

const closeButtonStyle = css({
    position: "absolute",
    top: 0,
    right: 0,
    marginTop: "calc(-0.5 * var(--globals-baseUnit))",
    marginRight: "calc(-0.5 * var(--globals-baseUnit))",
    zIndex: 10,
    backgroundColor: "white",
    borderRadius: "50%",
    width: "calc(4 * var(--globals-baseUnit))",
    height: "calc(4 * var(--globals-baseUnit))",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "var(--shadow-2)",
    cursor: "pointer",

    md: {
        marginTop: "calc(-1.5 * var(--globals-baseUnit))",
        marginRight: "calc(-1.5 * var(--globals-baseUnit))"
    },

    "&:hover": {
        backgroundColor: "var(--colors-gray-100)"
    }
});
import {useDispatch, useSelector} from "react-redux";
import {css} from "@panda/css";

import {CloseIcon} from "@pg-design/icons-module";
import {Modal} from "@pg-design/modal-module";
import {Text} from "@pg-design/text-module";
import {themeRP as theme} from "@pg-design/themes";

import {IRootState} from "../../store/store";
import {closeAuthModal, setLastAuthAction} from "../state/auth_modal_slice";
import {AuthActionType} from "../types/AuthActionType";
import {AuthModalBenefitDescription} from "./auth_modal/AuthModalBenefitDescription";
import {getAuthModalHeaderContent} from "./auth_modal/AuthModalHeaderVariants";
import {AuthCard} from "./AuthCard";

export const AuthModal = () => {
    const dispatch = useDispatch();
    const authModalState = useSelector((state: IRootState) => state.authModal);

    const onAuthSuccess = (authActionType: AuthActionType) => {
        dispatch(setLastAuthAction({authAction: authActionType}));
        dispatch(closeAuthModal());
    };

    const onClose = () => {
        dispatch(closeAuthModal());
    };

    if (!authModalState.isOpen || !authModalState.userSource) {
        return null;
    }

    const headerContent = getAuthModalHeaderContent(authModalState.headerVariant);

    return (
        <Modal isOpen shouldCloseOnEsc={false} shouldCloseOnOverlayClick={false} onModalClose={onClose}>
            <div className={modalContentStyle}>
                <div className={modalContentAuthCardWrapperStyle}>
                    <div className={closeButtonStyle} onClick={onClose}>
                        <CloseIcon size="1.6" />
                    </div>
                    <AuthCard
                        variant={authModalState.modalVariant}
                        onAuthSuccess={onAuthSuccess}
                        userSource={authModalState.userSource}
                        gtmSourceSection={authModalState.gtmSourceSection}
                        modalTitle={
                            <div className={headerSectionStyle}>
                                <Text align="center" variant="headline_3" className={headerTitleTextStyle}>
                                    {headerContent.title}
                                </Text>
                                <Text align="center" as="div" className={headerDescriptionTextStyle} color={theme.colors.gray[700]} variant="body_copy_2">
                                    {headerContent.description}
                                </Text>
                            </div>
                        }
                        modalDescription={null}
                        className={authCardStyle}
                        wrapperClassName={authCardWrapperStyle}
                    />
                </div>
                <AuthModalBenefitDescription className={benefitDescriptionWrapperStyle} variant={authModalState.headerVariant} />
            </div>
        </Modal>
    );
};

const modalContentStyle = css({
    display: "flex",
    flexDirection: "column",
    padding: 1.5,
    background: "var(--colors-info)",
    md: {
        width: "min(90dvw, 120rem)",
        alignItems: "flex-start",
        flexDirection: "row-reverse",
        padding: 4,
        maxHeight: "calc(100dvh - 8rem)",
        overflow: "auto"
    }
});

const modalContentAuthCardWrapperStyle = css({
    position: "relative"
});

const benefitDescriptionWrapperStyle = css({
    paddingY: 4,
    md: {
        padding: 4
    }
});

const authCardStyle = css({
    flex: "0 0 55rem",
    width: "100%",
    borderRadius: 2,
    boxShadow: "4",
    padding: 1.5,
    background: "white",
    "@media (min-width: 768px)": {
        width: "auto"
    },
    md: {
        width: "55rem",
        padding: 2
    }
});

const authCardWrapperStyle = css({
    padding: 0,
    md: {
        padding: 1,
        width: "auto"
    }
});

const headerSectionStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 1,
    marginBottom: 3,
    paddingRight: 3
});

const headerTitleTextStyle = css({
    textAlign: "center",
    md: {
        textAlign: "left"
    }
});

const headerDescriptionTextStyle = css({
    textAlign: "center",
    md: {
        textAlign: "left"
    }
});

const closeButtonStyle = css({
    position: "absolute",
    top: 0,
    right: 0,
    marginTop: "calc(-0.5 * var(--globals-baseUnit))",
    marginRight: "calc(-0.5 * var(--globals-baseUnit))",
    zIndex: 10,
    backgroundColor: "white",
    borderRadius: "50%",
    width: "calc(4 * var(--globals-baseUnit))",
    height: "calc(4 * var(--globals-baseUnit))",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "var(--shadow-2)",
    cursor: "pointer",

    md: {
        marginTop: "calc(-1.5 * var(--globals-baseUnit))",
        marginRight: "calc(-1.5 * var(--globals-baseUnit))"
    },

    "&:hover": {
        backgroundColor: "var(--colors-gray-100)"
    }
});
